var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSent02SolidStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1108 2.3908C21.7101 1.98851 21.0994 1.88559 20.5898 2.13447L2.84597 10.8008C2.32845 11.0535 2 11.5807 2 12.1584C2 12.7976 2.40093 13.3676 3.00095 13.5813L6.75949 14.9203L17.2805 8.16498L9.01399 15.7234V21.1032C9.01399 21.8746 9.63688 22.5 10.4053 22.5C10.894 22.5 11.3468 22.2426 11.5983 21.8219L14.1495 17.5529L17.8717 18.8789C18.0579 18.9453 18.2541 18.9792 18.4517 18.9792C19.2996 18.9792 20.0233 18.3638 20.1627 17.5241L22.4819 3.5535C22.5525 3.1285 22.4142 2.69546 22.1108 2.3908Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSent02SolidStandard);
export default __webpack_public_path__ + "static/media/sent-02-solid-standard.84f02af8d8c197c986b6ba830b528807.svg";
export { ForwardRef as ReactComponent };